<template>
  <AppHeaderDropdown right no-caret show>
    <template slot="header">
      <b-nav-item class="d-md-down-none">
        <i class="icon-user" style="color: #fff;"></i>
      </b-nav-item>
    </template>
    <template slot="dropdown">
      <b-dropdown-header
              tag="div"
              class="text-center">
        <strong>{{username}}</strong>
      </b-dropdown-header>
      <b-dropdown-item v-on:click="trigger"><i class="fa fa-lock" /> Passwort ändern</b-dropdown-item>
      <b-dropdown-item v-if="electron" v-on:click="triggerLogout"><i class="fa fa-sign-out" /> Nutzer wechseln</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
  import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
  export default {
    name: 'DefaultHeaderDropdownAccnt',
    components: {
      AppHeaderDropdown
    },
    props:{
      username: {
        type: String,
        default: "Einstellungen"
      }
    },
    data() {
      return {
        electron: false,
      }
    },
    mounted() {
      this.electron = this.isElectron();
    },
    methods: {
      trigger() {
        this.$emit('change-password');
      },
      triggerLogout() {
        this.$emit('switch-user');
      },
      isElectron() {
        let userAgent = navigator.userAgent.toLowerCase();
        return userAgent.indexOf(' electron/') > -1;
      },
    }
  }
</script>
